import AuthenticationView from '../view/AuthenticationView';

export default class AuthenticationForm extends AuthenticationView {
    constructor(json) {
        super(json);
        this.type = json.authenticationSettings.type;
    }
}
